import { useState } from 'react'
import { TextField, Button, type TextFieldProps } from '~/components/shared'
import { EyeIcon } from '../icons/EyeIcon'
import { EyeClosedIcon } from '../icons/EyeClosedIcon'

export interface PasswordFieldProps extends TextFieldProps {}

export function PasswordField(props: PasswordFieldProps) {
  const { type, endAdornment, ...rest } = props

  const [passwordVisible, setPasswordVisibility] = useState(false)

  const togglePasswordVisibility = () => setPasswordVisibility((prev) => !prev)

  return (
    <TextField
      type={passwordVisible ? 'text' : 'password'}
      endAdornment={
        <>
          <Button variant="text" className="w-10" onClick={togglePasswordVisibility}>
            {passwordVisible ? <EyeIcon className="h-6 w-6" /> : <EyeClosedIcon className="h-6 w-6" />}
          </Button>
          {endAdornment}
        </>
      }
      {...rest}
    />
  )
}
